import { Link, ComboboxOptionThumbnailContainer, FluidImage, ComboboxOptionTextContainer, Typography, Span } from '@vp/swan';
import React__default from 'react';
import ResultText from '../flyout/ResultText.js';
import localize from '../../../util/localize.js';
import { SEARCH_RESULT_RIGHT_CLICKED } from '../../../util/analyticsConstants.js';
import { useTracking } from './QuerySuggestionsSearchInputTrackingProvider.js';
import { getDestinationUrl } from '../../../util/destinationUrlBuilder.js';

var QuerySuggestionsSearchResultItem = function QuerySuggestionsSearchResultItem(props) {
  var _searchItem$_highligh;
  var searchItem = props.searchItem,
    locale = props.locale,
    query = props.query;
  var _useTracking = useTracking(),
    sendSearchResultClickEvent = _useTracking.sendSearchResultClickEvent;
  function handleOnRightClick(event, searchItem) {
    sendSearchResultClickEvent({
      eventName: SEARCH_RESULT_RIGHT_CLICKED,
      destinationUrl: getDestinationUrl({
        landingUrl: searchItem.landingUrl,
        query: query
      }),
      searchItem: searchItem
    });
  }
  return /*#__PURE__*/React__default.createElement(Link, {
    key: "link_".concat(searchItem.objectID),
    href: getDestinationUrl({
      landingUrl: searchItem.landingUrl,
      query: query
    }),
    onContextMenu: function onContextMenu(e) {
      return handleOnRightClick(e, searchItem);
    },
    onAuxClick: function onAuxClick(e) {
      return handleOnRightClick(e, searchItem);
    },
    py: 2,
    px: 5,
    className: "swan-listbox-option swan-listbox-option-with-thumbnail swan-listbox-option-content query-suggestion-item",
    style: {
      width: '100%'
    },
    skin: 'unstyled'
  }, searchItem.imageUrl && /*#__PURE__*/React__default.createElement(ComboboxOptionThumbnailContainer, null, /*#__PURE__*/React__default.createElement(FluidImage, {
    src: searchItem.imageUrl,
    alt: searchItem.title
  })), /*#__PURE__*/React__default.createElement(ComboboxOptionTextContainer, {
    py: 4
  }, /*#__PURE__*/React__default.createElement(Typography, {
    visuallyHidden: true
  }, searchItem.title), /*#__PURE__*/React__default.createElement(Typography, {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement(ResultText, {
    resultText: (_searchItem$_highligh = searchItem._highlightResult) === null || _searchItem$_highligh === void 0 || (_searchItem$_highligh = _searchItem$_highligh.title) === null || _searchItem$_highligh === void 0 ? void 0 : _searchItem$_highligh.value
  }), searchItem.inStock === false && /*#__PURE__*/React__default.createElement(Span, {
    display: "block",
    textAlign: "left",
    textColor: "subtle"
  }, /*#__PURE__*/React__default.createElement(Span, {
    fontSize: "xsmall",
    textColor: "standard",
    pr: 2
  }, "\u2022"), localize('outOfStock', locale)))));
};

export { QuerySuggestionsSearchResultItem as default };
//# sourceMappingURL=QuerySuggestionsSearchResultItem.js.map
